// Copyright (c) Docugami, Inc. All rights reserved.

import { InteractionStates, NotificationCategory } from "networking/NotificationsApi";

/**
 * Identifies the type of notification provider
 */
export enum NotificationProviderType {
    Service,
    Client
}

/**
 * The very minimum subset of information representing a notification such that
 * the UX can display a list of notifications without knowing the underlying implementation.
 * Only the associated provider knows how to turn the descriptor into its UI
 * representation.
 */
export interface INotificationDescriptor {
    providerType: NotificationProviderType
    id: string
    timestamp: Date
    category: NotificationCategory
    interactions: InteractionStates
}

/**
 * Interface for objects capable of providing notifications
 */
export interface INotificationProvider {
    descriptors: INotificationDescriptor[]
    createComponent(descriptor: INotificationDescriptor): JSX.Element | null
}
